import { TypedDocumentNode, gql } from '@apollo/client';
import styled, { CSSProperties } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import Dialog from '@sorare/core/src/components/dialog';
import { breakpoints, tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { BoxOdds } from '../BoxOdds';
import { BoxOddsDialog_probabilisticBundleConfig } from './__generated__/index.graphql';

const Wrapper = styled(Vertical)`
  padding: calc(6 * var(--unit)) var(--double-unit) var(--double-unit);
  @media ${tabletAndAbove} {
    min-width: ${breakpoints.mobile}px;
  }
`;

const BoxPreview = styled.img`
  width: calc(8 * var(--unit));
  height: calc(8 * var(--unit));
  object-fit: contain;
  filter: drop-shadow(0 0 20px var(--neon-color));
  align-self: center;
`;
type Props = {
  open: boolean;
  onClose: () => void;
  probabilisticBundleConfig: Nullable<BoxOddsDialog_probabilisticBundleConfig>;
};

export const BoxOddsDialog = ({
  open,
  onClose,
  probabilisticBundleConfig,
}: Props) => {
  const { name, pictureUrl, neonColor } = probabilisticBundleConfig || {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      title={
        <LabelL bold className="text-center">
          {name}
        </LabelL>
      }
    >
      <Wrapper gap={5}>
        <BoxPreview
          src={pictureUrl}
          alt={name}
          style={
            {
              '--neon-color': neonColor || 'var(--c-rivals-arena)',
            } as CSSProperties
          }
        />
        {probabilisticBundleConfig && (
          <BoxOdds boxConfig={probabilisticBundleConfig} />
        )}
      </Wrapper>
    </Dialog>
  );
};

BoxOddsDialog.fragments = {
  probabilisticBundleConfig: gql`
    fragment BoxOddsDialog_probabilisticBundleConfig on ProbabilisticBundleConfig {
      id
      name
      pictureUrl
      neonColor
      ...BoxOdds_probabilisticBundleConfig
    }
    ${BoxOdds.fragments.probabilisticBundleConfig}
  ` as TypedDocumentNode<BoxOddsDialog_probabilisticBundleConfig>,
};
